import { render, staticRenderFns } from "./myAppcenterManage.vue?vue&type=template&id=c1596960&"
import script from "./myAppcenterManage.vue?vue&type=script&lang=js&"
export * from "./myAppcenterManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports